/**
 * The submission sequence, named so failures can say *which* step failed
 * ("Step 2 of 3: generate School ID") and so a retry can resume from it
 * instead of re-creating guardians (§7.3, §7.6, §7.7).
 */

import type { SubmissionStep, SubmissionStepId } from './types.js';

export const NEW_STUDENT_STEPS: readonly SubmissionStep[] = [
  { id: 'create_guardians', label: 'Create/update guardians' },
  { id: 'generate_school_id', label: 'Generate School ID' },
  { id: 'create_applicant', label: 'Create student applicant' },
];

export const EXISTING_STUDENT_STEPS: readonly SubmissionStep[] = [
  { id: 'create_guardians', label: 'Update guardians' },
  { id: 'submit_existing', label: 'Update student and file applicant' },
];

export function stepsFor(applicantType: 'New' | 'Existing'): readonly SubmissionStep[] {
  return applicantType === 'Existing' ? EXISTING_STUDENT_STEPS : NEW_STUDENT_STEPS;
}

export function stepPosition(
  steps: readonly SubmissionStep[],
  id: SubmissionStepId,
): { number: number; total: number; label: string } {
  const index = steps.findIndex((s) => s.id === id);
  const step = index >= 0 ? steps[index] : undefined;
  return {
    number: index >= 0 ? index + 1 : 0,
    total: steps.length,
    label: step?.label ?? id,
  };
}

export function describeStep(
  steps: readonly SubmissionStep[],
  id: SubmissionStepId | undefined,
): string {
  if (!id) return '';
  const { number, total, label } = stepPosition(steps, id);
  return number ? `Step ${number} of ${total}: ${label}` : label;
}
